import { render, staticRenderFns } from "./FundRaising.vue?vue&type=template&id=245af55e&scoped=true&lang=html&"
import script from "./FundRaising.vue?vue&type=script&lang=js&"
export * from "./FundRaising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245af55e",
  null
  
)

export default component.exports